"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const LayoutVisualizerBlocks_1 = require("./LayoutVisualizerBlocks");
class LayoutVisualizerBlock extends react_1.default.Component {
    render() {
        const { block } = this.props;
        const hasChildBlocks = block.repeatChildBlocks && block.repeatChildBlocks.length > 1;
        const hasRepeatChildBlocks = block.repeatChildBlocks && block.repeatChildBlocks.length > 1;
        return (react_1.default.createElement(reactstrap_1.Card, { className: "p-2 mb-2" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("h4", { className: classnames_1.default({
                        'mb-0': !(hasChildBlocks || hasRepeatChildBlocks),
                        'mb-2': hasChildBlocks || hasRepeatChildBlocks,
                    }) }, block.type === 'repeater' ? (react_1.default.createElement(reactstrap_1.Badge, { className: "w-100", color: "info" }, "repeater")) : block.type === 'group' ? (react_1.default.createElement(reactstrap_1.Badge, { className: "w-100", color: "secondary" }, "group")) : block.type === 'field' ? (react_1.default.createElement(reactstrap_1.Badge, { className: "w-100", color: "primary" }, "field")) : (react_1.default.createElement(reactstrap_1.Badge, { className: "w-100", color: "warning" }, "unknown")))),
            hasChildBlocks && (react_1.default.createElement(reactstrap_1.Card, { className: "p-2 mb-2 bg-dark text-white" },
                react_1.default.createElement("p", { className: "lead text-white" },
                    block.childBlocks.length,
                    " child block",
                    block.childBlocks.length !== 1 && 's'),
                react_1.default.createElement(LayoutVisualizerBlocks_1.LayoutVisualizerBlocks, { blocks: block.childBlocks, isChild: true }))),
            hasRepeatChildBlocks && (react_1.default.createElement(reactstrap_1.Card, { className: "p-2 mb-2 bg-dark text-white" },
                react_1.default.createElement("p", { className: "lead text-white" },
                    block.repeatChildBlocks.length,
                    " repeatable child block",
                    block.repeatChildBlocks.length !== 1 && 's'),
                react_1.default.createElement(LayoutVisualizerBlocks_1.LayoutVisualizerBlocks, { blocks: block.repeatChildBlocks, isChild: true })))));
    }
}
exports.LayoutVisualizerBlock = LayoutVisualizerBlock;
//# sourceMappingURL=LayoutVisualizerBlock.js.map